module.exports = __webpack_public_path__ + "img/wg.24d94f13.png";